import axios from 'axios';

export const GET_USER_DATA = '[CHAT PANEL] GET USER DATA';

